import { Send } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { MicButton } from "@/components/MicButton";
import { errText } from "@/components/pipeline/utils";

// Saisie du commentaire (clavier ou dictée), Ctrl+Entrée pour publier
export const Composer = ({ leadId, onComment }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim() || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/pipeline/leads/${leadId}/comments`, { content: text.trim() });
      onComment(data);
      setText("");
      const n = Object.keys(data.filled || {}).length;
      toast.success(n ? `Commentaire enregistré · ${n} champ${n > 1 ? "s" : ""} rempli${n > 1 ? "s" : ""} depuis le script.` : (leadId < 0 ? "Commentaire enregistré (fiche TEST)." : "Commentaire enregistré (copie noCRM automatique)."));
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <section className="card ldx-composer" data-testid="lead-composer">
      <textarea id="lead-comment-input" rows={3} value={text} placeholder="Compte rendu de l'appel, script de qualification… (C pour écrire, Ctrl+Entrée pour publier)" onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) send(); }} data-testid="opportunity-comment-input" />
      <div className="ldx-composer__bar">
        <MicButton onText={(t) => setText((v) => (v ? `${v} ${t}` : t))} testid="lead-comment-mic" label="Dicter" />
        <button type="button" className="btn btn--sm btn--ink" disabled={busy || !text.trim()} onClick={send} data-testid="opportunity-comment-submit-btn"><Send size={14} /> {busy ? "Envoi…" : "Publier"}</button>
      </div>
    </section>
  );
};
